<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-row class="align-items-center">
      <b-col cols="12" md>
        <b-form-textarea v-model="form.content" :state="isValidField('content')" rows="3" />
      </b-col>
      <b-col cols="12" md="auto" class="text-right p-3">
        <b-button :disabled="submitting" pill variant="outline-primary" class="mr-2" @click="$emit('cancel')">Cancel</b-button>
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-4 pr-4">Send</b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import validator from 'validator'
import MixinForm from './MixinForm'

export default {
  name: 'SendMessageInlineForm',

  mixins: [MixinForm],

  props: {
    content: {
      type: String,
      default: ''
    },

    receivers: {
      type: Array,
      default: () => ([])
    },

    category: {
      type: String,
      required: true
    },

    feed: {
      type: Number
    }
  },

  watch: {
    content(value) {
      this.form.content = value
    },

    receivers(value) {
      this.form.receivers = value.map(p => ({ value: p.receiver.id, type: p.type }))
    },

    category(value) {
      this.form.category = value
    },

    feed(value) {
      this.form.feed = value
    }
  },

  data() {
    return {
      form: {
        category: this.category,
        content: this.content,
        receivers: this.receivers.map(p => ({ value: p.receiver.id, type: p.type })),
        feed: this.feed
      }
    }
  },

  methods: {
    validate(data) {
      const errors = {}
      if (validator.isEmpty(data.content)) errors.content = ["Message can't be blank"]
      return errors
    },

    prepare(data) {
      const { receivers, ...other } = data
      return { ...other, receivers: receivers.map(p => ({ id: p.value, type: p.type })) }
    }
  }
}
</script>
